exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ace-editor[data-v-f3a37ca0]{min-height:300px}\n", ""]);

// exports
